import { LayoutIcon } from '@sharedCR/coreDesignSystem/icons';

import { HeaderTestIds } from './Header.testIds';

const commonIconButtonProps = {
  disabled: true,
  iconClassName: 'text-24',
  size: 'small',
  variant: 'outlined',
};

const headerConfigFields = {
  generateBundleIcon: {
    'data-testid': HeaderTestIds.DOCUMENT_TREE_HEADER_GENERATE_BUNDLE_ICON_BUTTON,
    icon: LayoutIcon,
    title: 'Generate bundle',
    ...commonIconButtonProps,
  },
};

export const getHeaderIconButtonsConfig = ({
  isGenerateBundleIconDisabled,
  onGenerateBundleClick,
  isGenerateBundleAllowed,
}) => {
  const config = [];

  if (isGenerateBundleAllowed) {
    config.push({
      ...headerConfigFields.generateBundleIcon,
      disabled: isGenerateBundleIconDisabled,
      onClick: onGenerateBundleClick,
    });
  }

  return config;
};

export const getCheckboxesHeaderConfig = ({
  isEmptyTreeItemVisible,
  isDeletedDocumentsVisible,
  isRejectedOnlyVisible,
  onChangeEmptyTreeItemVisibility,
  onChangeDeletedDocumentsVisibility,
  onChangeRejectedOnlyVisibility,
}) => {
  return [
    {
      fullWidth: true,
      'data-testid': HeaderTestIds.DOCUMENT_TREE_HEADER_HIDE_EMPTY_CATEGORIES_AND_DOCTYPES_CHECKBOX,
      label: 'Hide empty',
      value: !isEmptyTreeItemVisible,
      onChange: onChangeEmptyTreeItemVisibility,
    },
    {
      fullWidth: true,
      'data-testid': HeaderTestIds.DOCUMENT_TREE_HEADER_HIDE_DELETED_DOCUMENTS_CHECKBOX,
      label: 'Hide deleted',
      value: !isDeletedDocumentsVisible,
      onChange: onChangeDeletedDocumentsVisibility,
    },
    {
      fullWidth: true,
      'data-testid': HeaderTestIds.DOCUMENT_TREE_HEADER_REJECTED_ONLY_CHIP,
      label: 'Rejected only',
      value: !!isRejectedOnlyVisible,
      onChange: onChangeRejectedOnlyVisibility,
    },
  ];
};
